module.exports = __webpack_public_path__ + "media/images/icons/flags/TH-b68cd3a68c30179eb7734804be848cb3.svg";